module.exports = __webpack_public_path__ + "img/dentimport.bffe418d.svg";